export enum DeployEnv {
  Dev = "dev",
  Staging = "staging",
  Prod = "prod",
  Local = "local",
}

export function getVidmuseDeployEnv(deployHost?: string): DeployEnv {
  let host = deployHost || "";
  if (typeof window !== "undefined") {
    host = window.location.host;
  }

  if (host.endsWith("vidmuse-dev.sandaii.cn")) {
    return DeployEnv.Dev;
  }

  if (host.endsWith("vidmuse-staging.sandaii.cn")) {
    return DeployEnv.Staging;
  }

  if (host.endsWith("vidmuse.ai")) {
    return DeployEnv.Prod;
  }

  return DeployEnv.Local;
}

export const VIDMUSE_DEPLOY_ENV = getVidmuseDeployEnv();
